import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Game } from '../../../Core'

import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'
import * as miningActions from '../../Mining/mining.actions'

/**
 *  Pop up showed when you want to refuse a question
 */
class RefuseAlertPopup extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
  }

  removePopup(canContinue) {
    const { changeMiningScreen, removePopup, addHowlSound } = this.props
    if (canContinue) {
      changeMiningScreen('refuse_question')
    }
    canContinue ? addHowlSound('button_click') : addHowlSound('button_click_icon')
    removePopup('refuse_question_alert')
  }

  render() {
    const canContinue = true

    return (
      <div className="popup--game">
        <div className="popup--box">
          <div className="popup--box__canvas">
            <div className="popup--heading">
              <FormattedMessage id="questions.refuseQuestionAlert.title" />
            </div>
            <div className="popup--text">
              <FormattedMessage id="questions.refuseQuestionAlert.text" />
            </div>
            <div className="popup--buttons">
              <div
                onClick={() => {
                  this.removePopup()
                }}
                className="btn--shape shape--blue"
              >
                <div className="btn--shape__canvas">
                  <FormattedMessage id="questions.refuseQuestionAlert.cancel" />
                </div>
              </div>
              <div
                className={`btn--shape shape--blue`}
                onClick={() => {
                  this.removePopup(canContinue)
                }}
              >
                <div className="btn--shape__canvas">
                  <FormattedMessage id="questions.refuseQuestionAlert.accept" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeMiningScreen: bindActionCreators(miningActions.changeMiningScreen, dispatch),
    removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  }
}

RefuseAlertPopup.propTypes = {
  changeMiningScreen: PropTypes.func,
  removePopup: PropTypes.func,
  addHowlSound: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(injectIntl(RefuseAlertPopup))
